export class MediaDevice{
    DeviceId = '';
    DeviceName = '';
    Type = '';
}